/** Text version of a chart, for keyboard and screen-reader users. */
export default function ChartNumbers({ caption, columns, rows }) {
  if (!rows?.length) return null;
  return (
    <details className="border-t border-line">
      <summary className="cursor-pointer px-4 py-3 text-sm font-semibold text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand">
        Show the numbers
      </summary>
      <div className="overflow-x-auto px-4 pb-4">
        <table className="w-full text-left text-sm">
          <caption className="sr-only">{caption}</caption>
          <thead>
            <tr className="text-[12px] text-muted">
              {columns.map((column) => (
                <th key={column} scope="col" className="py-2 pr-3 font-medium last:text-right">
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={`${row[0]}-${index}`} className="border-t border-gray-100">
                {row.map((cell, cellIndex) =>
                  cellIndex === 0 ? (
                    <th key={cellIndex} scope="row" className="py-1.5 pr-3 font-medium text-ink">
                      {cell}
                    </th>
                  ) : (
                    <td key={cellIndex} className="py-1.5 pr-3 tabular-nums text-ink last:text-right">
                      {cell}
                    </td>
                  )
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </details>
  );
}
